<template>
  <div class="page">
    <div class="head">
      <img width="100%" src="../assets/cp-7.jpg" alt="">
      <div class="des">
        <div class="title">{{title}}</div>
        <div class="text">以更简单的方式协同工作，快速获取意想不到的新洞察，并提供<br>改变业务的结果</div>
        <div class="icon" @click="goFile()" style="cursor: pointer;">
          <Icon style="padding-right: 10px" size="16" type="md-arrow-forward" />联系INCO获取更多信息
        </div>
      </div>
    </div>
    <div class="nav">
      <span class="nav-item" v-for="(item, index) in data" :key="index">{{item.title}}</span>
    </div>
    <div class="item" v-for="(item, index) in data" :key="index">
      <div class="introduce-wrap">
        <div class="introduce">
          <div class="title"><span style="font-weight: 700">{{item.title}}</span><br>概述</div>
          <div class="text" v-if="item.list.length > 0">
            <p style="width: 730px;">{{item.list[0].title}}</p>
          </div>
        </div>
      </div>
      <div class="function-wrap">
        <div class="function">
          <div class="title">产品功能</div>
          <div class="text" v-if="item.list.length > 0">
            <p style="width: 730px;padding-bottom: 0;">{{item.list[0].remark01}}</p>
          </div>
        </div>
      </div>
      <div class="advantage-wrap" v-if="item.children[0].list.length>0">
        <div class="advantage">
          <div class="title" style="text-align: right;">产品优势</div>
          <div class="card-wrap">
            <Row :gutter="10" type="flex" justify="start" class="code-row-bg">
              <Col :span="item.children[0].list.length>4 ? 8 : 12" v-for="(item1, index) in item.children[0].list" :key="index">
              <Card class="bg" :padding="0" :style="getStyles(item.children[0].list,index)">
                <div class="card-item">
                  <p class="title">{{item1.title}}</p>
                  <p class="text">{{item1.remark01}}</p>
                </div>
              </Card>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div class="about">
        <div class="title">相关产品</div>
        <div class="text" @click="goToNewPage(index, data)" v-if="item.list.length > 0">{{item.list[0].remark16}}
          <div style="text-align: right;">
            <Icon style="padding-right: 10px" size="26" type="md-arrow-forward" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data() {
    return {
      title: '',
      num: 8,
      navList: ['内容资源类', '虚拟仿真实验', '设备环境类', '学生成绩打印一体机', '智慧教室'],
      data: [
        {
          title: '数字校园基础平台',
          list: [{ title: '统一数据标准与身份认证，提供一站式服务门户，实现门户、数据、身份三大融合，支撑智慧校园建设。', remark01: '提供统一身份认证、统一数据交换与共享、一站式服务门户等核心能力，覆盖师生在校学习生活的全场景应用。', remark16: '了解更多数字校园相关产品' }],
          children: [{ list: [
            { title: '统一身份认证', remark01: '多源身份整合，单点登录' },
            { title: '数据共享与治理', remark01: '数据清洗、治理与可视化' },
            { title: '一站式服务门户', remark01: '个性化服务大厅，网上办事' },
            { title: '移动校园应用', remark01: '随时随地便捷访问' },
          ] }],
        },
        {
          title: '教务管理系统',
          list: [{ title: '覆盖学籍、培养方案、排课选课、成绩管理与毕业审核，支撑教学运行全过程。', remark01: '支持学年学分制与完全学分制混合模式，提供智能排课、选课、考务、成绩、毕业审核等全流程管理能力。', remark16: '了解更多教务相关产品' }],
          children: [{ list: [
            { title: '学籍管理', remark01: '学籍异动全流程管理' },
            { title: '智能排课', remark01: '资源冲突智能检测' },
            { title: '选课管理', remark01: '多轮选课，实时容量控制' },
            { title: '成绩管理', remark01: '成绩录入、分析与预警' },
          ] }],
        },
      ],
      index: 3,
    }
  },
  methods: {
    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      let search = window.location.href.split('?')[1]
      if (search) {
        var r = search.substr(0).match(reg)
        if (r !== null) return unescape(r[2])
        return null
      } else {
        return null
      }
    },
    getStyles(list, index) {
      var array = []
      if (list.length === 4) {
        array = ['03', '05', '09', '10']
        return {
          backgroundImage: 'url(' + require(`../assets/产品中心三级页面1_${array[index]}.png`) + ')',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }
      } else {
        array = [0, 1, 2, 3, 4, 5, 0, 1, 2, 3, 4, 5, 0, 1, 2, 3, 4, 5]
		let url = ''
		if (index === 1 || index === 0) {
			url = 'url(' + require(`../assets/cp-${array[index]}.png`) + ')'
		} else{
			url = 'url(' + require(`../assets/cp-${array[index]}.jpg`) + ')'
		}
        return {
          backgroundImage: url,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }
      }
    },
    goToNewPage(index, data) {
      window.localStorage.setItem('productJson1', JSON.stringify(data))
      if (this.index == 0) {
        // this.$router.push({
        //   path: 'products_4',
        //   query: { currentIndex: index, id: this.$route.query.id },
        // })
		let routeUrl = this.$router.resolve({
		     path: 'products_4',
		     query: { currentIndex: index, id: this.$route.query.id },
		   });
		window.open(routeUrl.href, '_blank');
      } else {
        // this.$router.push({
        //   path: 'production',
        //   query: { title: this.title, id: this.$route.query.id },
        // })
		let routeUrl = this.$router.resolve({
		       path: 'production',
		       query: { title: this.title, id: this.$route.query.id },
		   });
		window.open(routeUrl.href, '_blank');
      }
    },
    getData() {
      let url =
        this.HOST +
        'inconWeb/getFlProductsByParentId?moduleOrder=ordernum&contentOrder=ordernum&websiteid=4&parentid=D9397F9B122A24E5E05509994F3826F5'
      url = this.$getJsonUrl(url)
      this.$axios.get(url).then((res) => {
        let list = res.data.content.list
        this.data = list
      })
    },
    getDatas() {
      let url1 =
        this.HOST +
        'inconWeb/getFlProductsByParentId?moduleOrder=ordernum&contentOrder=ordernum&websiteid=4&parentid=D9397F9B122B24E5E05509994F3826F5'
      url1 = this.$getJsonUrl(url1)
      this.$axios.get(url1).then((res) => {
        let list1 = res.data.content.list
        let url2 =
          this.HOST +
          'inconWeb/getFlProductsByParentId?moduleOrder=ordernum&contentOrder=ordernum&websiteid=4&parentid=D939C9CDA7BC3124E05509994F3826F5'
        url2 = this.$getJsonUrl(url2)

        console.log(url2)

        this.$axios.get(url2).then((res) => {
          let list2 = res.data.content.list
          this.data = [...list1, ...list2]

          console.log(this.data)
        })
      })
    },
	goFile(){
		window.open(this.HOST+"incon/upFile/accessory/xcsc_01.pdf")
	}
  },
  mounted() {
    this.index = this.$route.query.index
    // this.title = this.$route.query.title
    // let parentid = this.$route.query.id
    // let type = this.getUrlParam('type')
    let paramsId = this.getUrlParam('id')

    if (this.index == 0) {
      this.title = '软件系统类'
      this.getData()
    } else if (this.index == 1 || this.index == 2) {
      this.title = '内容资源类 / 设备环境类'
      this.getDatas()
    } else {
      if ((paramsId = 'D9397F9B122A24E5E05509994F3826F5')) {
        this.title = '软件系统类'
        this.getData()
      } else if ((paramsId = 'D9397F9B122B24E5E05509994F3826F5')) {
        this.title = '内容资源类 / 设备环境类'
        this.getDatas()
      } else if ((paramsId = 'D939C9CDA7BC3124E05509994F3826F5')) {
        this.title = '内容资源类 / 设备环境类'
        this.getDatas()
      }
    }
  },
}
</script>

<style scoped lang="less">
.page {
  .head {
    position: relative;
    font-size: 0;
    .des {
      position: absolute;
      left: 50%;
      bottom: 50%;
      transform: translate(-50%, 50%);
      // width: 60%;
      width: 1000px;
      color: #fff;
      .title {
        font-size: 18px;
        font-weight: 600;
        line-height: 30px;
      }
      .text {
        padding-bottom: 10px;
        font-size: 16px;
        line-height: 20px;
      }
      .icon {
        font-size: 14px;
      }
    }
  }
  .nav {
    display: flex;
    background-image: url('../assets/zpqs-3.jpg');
    background-repeat: no-repeat;
    background-size: cover;
    .nav-item {
      flex: 1;
      line-height: 40px;
      font-size: 15px;
      font-weight: 500;
      text-align: center;
      color: #fff;
      border-right: 1px solid white;
      &:last-child {
        border-right: 0 solid white;
      }
    }
  }
  .item {
    font-size: 17px;
    .introduce-wrap {
      margin: 0 auto;
      background: rgb(239, 240, 241);
    }
    .function-wrap {
      margin: 0 auto;
      background: rgb(2, 31, 52);
    }
    .advantage-wrap {
      width: 1000px;
      margin: 0 auto;
    }
    .introduce {
      display: flex;
      width: 1000px;
      margin: 0 auto;
      padding: 30px 0 40px 0;
      .title {
        margin: 0 100px 0 50px;
        width: 120px;
        text-align: right;
        color: #333;
      }
      .text {
        flex: 1;
      }
    }
    .function {
      display: flex;
      width: 1000px;
      margin: 0 auto;
      padding: 10px 0;
      .title {
        margin: 0 100px 0 50px;
        width: 120px;
        text-align: right;
        line-height: 50px;
        color: #999;
      }
      .text {
        flex: 1;
        font-size: 17px;
        font-weight: 600;
        line-height: 50px;
        color: #fff;
      }
    }
    .advantage {
      display: flex;
      margin: 0 auto;
      padding: 10px 0;
      .title {
        width: 120px;
        margin: 0 100px 0 50px;
        text-align: right;
      }
      .card-wrap {
        flex: 1;
        margin-bottom: 10px;
        .bg {
          position: relative;
          width: 100%;
          height: 100%;
          padding-bottom: 10px;
          background-image: url('../assets/zpqs-3.jpg');
          background-repeat: no-repeat;
          background-size: cover;
          background-position: center center;
          color: #fff;
          .card-item {
            width: 100%;
            height: 100%;
            padding: 16px;
          }
          .title {
            width: 100%;
            margin: 0;
            padding: 0 0 20px 0;
            padding-right: 0;
            line-height: 40px;
            text-align: left;
            font-size: 18px;
            font-weight: 600;
          }
          .text {
            height: 100px;
            width: 190px;
            line-height: 30px;
            font-size: 16px;
          }
        }
      }
    }
    .about {
      display: flex;
      width: 1000px;
      margin: 0 auto;
      padding: 30px 0 40px 0;
      .title {
        width: 120px;
        margin: 0 100px 0 50px;
        text-align: right;
      }
      .text {
        flex: 1;
      }
    }
  }
}
.card-wrap /deep/ .ivu-card-body {
  padding: 0;
}

.card-wrap /deep/ .ivu-col {
  margin-bottom: 10px !important;
}
</style>